/**
 * Privacy policy and support links. App Store Guideline 5.1.1(i) wants the
 * policy reachable inside the app, not only on the store listing. In the
 * native app target="_blank" hands the URL to Safari (Capacitor opens every
 * new-window request externally).
 */
// Trailing slash on purpose: readybreak.app is the app's universal-link domain,
// and only /privacy/* and /support/* are excluded in apple-app-site-association.
// Without the slash iOS could route the tap straight back into the app (the
// reviewer taps "Privacy policy" and nothing opens).
import { kvGet, kvSet } from '@coach/core';
import { useEffect, useState } from 'react';

export const PRIVACY_URL = 'https://readybreak.app/privacy/';
export const SUPPORT_URL = 'https://readybreak.app/support/';

/** Date of the last privacy-policy change that coaches should be told about. */
export const PRIVACY_UPDATED = '2026-10-01';
const SEEN_KEY = 'privacy_notice_seen';

/**
 * One-time "the privacy policy changed" bar. The policy promises the app will
 * say so when what is collected or who can see it changes; bump
 * PRIVACY_UPDATED with the page's date when that happens. Per device.
 */
export function PolicyNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    void kvGet<string>(SEEN_KEY).then((v) => setShow((v ?? '') < PRIVACY_UPDATED));
  }, []);
  if (!show) return null;
  const dismiss = () => {
    setShow(false);
    void kvSet(SEEN_KEY, PRIVACY_UPDATED);
  };
  return (
    <div className="policy-notice row" role="status">
      <span className="grow small">
        Privacy policy updated: it now covers Game mode play counts and when the people who run Ready Break can reach stored data.{' '}
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" onClick={dismiss}>Read it</a>
      </span>
      <button className="btn btn-sm" onClick={dismiss} aria-label="Dismiss">OK</button>
    </div>
  );
}

export function LegalLinks({ style }: { style?: React.CSSProperties }) {
  return (
    <div className="muted small" style={{ textAlign: 'center', ...style }}>
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">Privacy policy</a>
      {' · '}
      <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">Support</a>
    </div>
  );
}
